import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent implements OnInit {

  private _value:string = '';

  displayValue:string = "";

  //@Input() value: string = 'text';
  @Input() className:string = '';

  @Input()
  public get value(): any {
    return this._value;
  }

  public set value(v: any) {
    if (v !== this._value) {
      this._value = v;
      let arr = v.split(' ');
      //this.displayValue = arr[0].toUpperCase() + ' ' +  arr[1].toUpperCase();
      this.displayValue =v;
    }
  }

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/avatar/avatar.component.ts